import axios from "axios";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { auth } from "../service/firebaseConfig"; // Chemin vers votre fichier d'initialisation Firebase
import Cookies from "js-cookie";

const checkSessionByCookie = () => {
  const token = Cookies.get("user_session");
  if (token) {
    console.log(
      "L'utilisateur est toujours connecté, son token est présent :",
      token
    );
    return token;
  } else {
    console.log("Pas de session active.");
    return null;
  }
};

const checkAuth = async () => {
  return new Promise((resolve, reject) => {
    const PUBLIC_ROUTES = [
      "login",
      "forgot-password",
      "register",
      "documentation",
      "login_proz",
    ];

    const isPublicPage = PUBLIC_ROUTES.some((r) =>
      window.location.href.includes(r)
    );
    const user = auth.currentUser;
    console.log("L'utilisateur actuel est : ", user);
    const token = checkSessionByCookie();

    if (!user && !token && !isPublicPage) {
      console.log("Redirection vers la page de login");
      window.location.href = "/login";
      reject("Utilisateur non connecté");
      return;
    }

    if (user) {
      try {
        user
          .getIdToken(true)
          .then((TOKEN) => {
            console.log("TOKEN IS ", TOKEN);

            axios.defaults.headers.common["Authorization"] = `Bearer ${TOKEN}`;

            axios.interceptors.request.use(
              function (config) {
                //document.body.classList.add("loading-indicator");
                return config;
              },
              function (error) {
                return Promise.reject(error);
              }
            );

            axios.interceptors.response.use(
              function (response) {
                //document.body.classList.remove("loading-indicator");
                return response;
              },
              function (error) {
                //document.body.classList.remove("loading-indicator");
                return Promise.reject(error);
              }
            );

            resolve(TOKEN); // Résout la promesse avec le token
          })
          .catch((error) => {
            console.error("Erreur lors de la récupération du token : ", error);
            reject(error); // Rejette la promesse en cas d'erreur
          });
      } catch (error) {
        console.log("Erreur lors de la configuration du token :", error);
        reject(error);
      }
    } else if (token) {
      // Si un token de session existe, on pourrait vouloir également résoudre la promesse avec ce token
      // ou effectuer une validation supplémentaire du token ici
      resolve(token);
    }
  });
};

export default checkAuth;
